import classNames from "classnames";
import React from "react";

export interface RadioGroupProps<T> {
  wrapperClassName?: string;
  orientation: "horizontal" | "vertical";
  disabled?: boolean;
  error?: boolean;
  options: {
    label?: React.ReactNode;
    value: T;
    renderOnSelect?: (value: T) => React.ReactNode;
  }[];
  value: T;
  onChange: (value: T) => void;
}

export const RadioGroup = <T extends string | number>({ wrapperClassName, orientation, disabled, error, options, value, onChange }: RadioGroupProps<T>) => {
  const labelClassNames = classNames("checkbox-radio-with-label", {
    "checkbox-radio-with-label-error": error,
  });

  return <div className={classNames(`radio-group-${orientation}`, wrapperClassName)}>
    {options.map((option) => <React.Fragment key={option.value}>
      <label className={labelClassNames}>
        <input style={{ minWidth: 20 }} tabIndex={0} disabled={disabled} type="radio" checked={value === option.value} onChange={() => onChange(option.value)} />
        {option.label}
      </label>
      {option.renderOnSelect && value === option.value && option.renderOnSelect(value)}
    </React.Fragment>)}
  </div>
}

export interface SingleRadioProps<T> {
  disabled?: boolean;
  error?: boolean;
  value: T;
  selected: T;
  onChange: (value: T) => void;
}

// This is a standalone radio button that should only be used in more complex input components,
//  like the PriceInput component. This is to give us more control in case of complex radio button groups.
export const SingleRadio = <T extends string | number | boolean>({ disabled, error, value, selected, onChange }: SingleRadioProps<T>) => {
  const labelClassNames = classNames("checkbox-radio-with-label", {
    "checkbox-radio-with-label-error": error,
  });

  return <label className={labelClassNames}>
    <input style={{ minWidth: 20 }} tabIndex={0} disabled={disabled} type="radio" checked={value === selected} onChange={() => onChange(value)} />
  </label>
}